<template>
  <div>
    <div class="oa-activiti">
      <div class="activiti-title">审批流图示</div>
      <div class="activiti-details">
        <a-spin
          v-if="aSpin"
          tip="流程图正在加载中 请稍后..."
          class="activiti-spin"
        />
        <div class="bpmn-canvas" ref="canvas"></div>
        <!-- 工具栏显示的地方 -->
        <div class="bpmn-js-properties-panel" id="js-properties-panel"></div>
      </div>
      <!-- <div class="activiti-title">审批节点配置</div>
      <div class="activiti-details">
        <div class="activit-select">
          <p class="select-title">请选择工作流所属业务及部门：</p>
          <div class="select-contion">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model="activitSelectData"
              placeholder="请选择工作流所属业务及部门"
              style="min-width: 250px"
              @change="activitSelect"
            >
              <a-select-option value="1">大宝公司/财务部/张三</a-select-option>
            </a-select>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import BpmnModeler from 'bpmn-js/lib/Modeler'
// 工具栏相关
import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda'
import propertiesPanelModule from 'bpmn-js-properties-panel'
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda'
// 汉化
import customTranslate from '@/avtiviti/customTranslate'
import { getDefinitionXML, getUserTasks } from './api/api'
export default {
  data() {
    return {
      bpmnModeler: null,
      canvas: null,
      bpmnTemplate: '',
      pQuery: [],
      activitSelectData: [],
      aSpin: true
    }
  },
  mounted() {
    if (this.$route.query) {
      this.pQuery = this.$route.query
      // 默认渲染 审批流图
      this.getDefinitionXMLFn()
      // 默认渲染 审批流图
      // this.getUserTasksFn()
    }
  },
  methods: {
    // 请选择工作流所属业务及部门
    activitSelect(value) {
      console.log(value)
    },
    // 默认渲染 审批流图
    getDefinitionXMLFn() {
      const params = {
        deploymentId: this.pQuery.deploymentId,
        resourceName: this.pQuery.resourceName,
        processDefinitionId: this.pQuery.processDefinitionId
      }
      getDefinitionXML(params).then((res) => {
        if (res.status === 200) {
          this.aSpin = false
          this.bpmnTemplate = res.data
          this.init()
        }
      })
    },
    // 默认查询流程的所用用户节点
    getUserTasksFn() {
      const params = {
        processDefinitionId: this.pQuery.processDefinitionId
      }
      getUserTasks(params).then((res) => {})
    },
    async init() {
      // 获取画布 element
      this.canvas = this.$refs.canvas
      // 将汉化包装成一个模块
      const customTranslateModule = {
        translate: ['value', customTranslate]
      }
      // 创建Bpmn对象
      this.bpmnModeler = new BpmnModeler({
        // 设置bpmn的绘图容器为上门获取的画布 element
        container: this.canvas,

        // 加入工具栏支持
        propertiesPanel: {
          parent: '#js-properties-panel'
        },
        additionalModules: [
          propertiesProviderModule,
          propertiesPanelModule,
          // 汉化模块
          customTranslateModule,
          {
            paletteProvider: ['value', ''],
            labelEditingProvider: ['value', ''],
            contextPadProvider: ['value', ''],
            bendpoints: ['value', {}],
            zoomScroll: ['value', ''],
            moveCanvas: ['value', '']
          }
        ],
        moddleExtensions: {
          activiti: camundaModdleDescriptor
        }
      })
      await this.createNewDiagram(this.bpmnTemplate)
      const elementRegistry = this.bpmnModeler.get('elementRegistry')
      this.nodeList = elementRegistry.filter(
        (item) =>
          item.type === 'bpmn:UserTask' || item.type === 'bpmn:ServiceTask'
      )
      // 此时得到的userTaskList 便是流程图中所有的节点的集合
      // // 步骤2 ：为节点添加颜色
      // // 方式1 ：modeling.setColor(参数1：节点，可以是单个元素实例，也可是多个节点组成的数组，参数2：class类);
      // let modeling = this.bpmnModeler.get('modeling')
      // modeling.setColor(this.nodeList[0], {
      //   stroke: 'green',
      //   fill: 'yellow'
      // })
    },
    async createNewDiagram(bpmn) {
      // 将字符串转换成图显示出来;
      this.bpmnModeler.importXML(bpmn, (err) => {
        if (err) {
          // this.$Message.error('打开模型出错,请确认该模型符合Bpmn2.0规范')
        } else {
          let canvas = this.bpmnModeler.get('canvas')
          canvas.zoom('fit-viewport', 'auto')
        }
      })
    }
  }
}
</script>

<style scoped>
.oa-activiti {
  height: auto;
  overflow: hidden;
  margin: 20px;
}
.activiti-details {
  height: 60vh;
  overflow: hidden;
  background: #fff;
  margin-bottom: 20px;
  position: relative;
}
.bpmn-canvas {
  width: 100%;
  height: 100%;
}
/* /deep/ .bpmn-canvas .viewport {
  transform: matrix(1, 0, 0, 1, -250, -150) !important;
} */
#js-properties-panel {
  display: none;
}
/deep/ .bjs-powered-by {
  display: none !important;
}
.activiti-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  text-indent: 2em;
  background: #fff;
  color: #333;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 2px solid #f5f5f5;
}
.activit-select {
  display: flex;
  height: auto;
  overflow: hidden;
  margin: 20px;
}
.select-title {
  line-height: 35px;
}
.select-contion {
  height: auto;
  overflow: hidden;
}
.activiti-spin {
  position: absolute !important;
  left: 45% !important;
  top: 45% !important;
  z-index: 100 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/system/activitiList/activitiDetails.vue